<template>
  <el-input :type="spec.inputType"
            :name="_name"
            v-model="value"
            :min="spec.min"
            :max="spec.max"
            :maxlength="spec.maxlength"
            :placeholder="spec.placeholder"
            :readonly="_readonly"
  ></el-input>
</template>

<script>
  import mixin from './mixin';
  import {Input} from 'element-ui';
  import {getField, setField} from 'src/schemas/utils';

  export default {
    name: 'f-input',
    mixins: [mixin],
    components: {[Input.name]: Input},
    computed: {
      value: {
        get() {
          return getField.call(this, this.model, this.spec);
        },
        set(v) {
          return setField.call(this, this.model, this.spec, this.spec.inputType === 'number' ? parseFloat(v) : v);
        },
      },
    },
  };
</script>



// WEBPACK FOOTER //
// f-input.vue?5080a286